<div class="w-full">
  <!--GREY LINE-->
  <app-standard-progression
    [ethnicity]="ethnicity"
    (ethnicityChanged)="onEthnicityChange($event)"
    [mostMyopicEyeSide]="calculationResults.serCalcResponse.mostMyopicEye ?? calculationResults.axialCalcResponse.mostMyopicEye!"
    [ageAtProgression]="calculationResults.standardProgressionReponse.ageAtProgression"
    [leftEyeProgressionStat]="calculationResults.standardProgressionReponse.leftEyeResults"
    [rightEyeProgressionStat]="calculationResults.standardProgressionReponse.rightEyeResults"></app-standard-progression>
  <app-myopia-progression-eim-retest [retestMonths]="retestPeriodMonths"></app-myopia-progression-eim-retest>
</div>
